<div class="container text-right">
    <h1 class=" text-center py-3 pb-4">متاجر على منصتنا</h1>

    <section id="cards">
        <div class="row justify-content-center py-4">
            <div class="col-md-3 ">
                <div class="card p-4 ">
                    <p class="card-title text-center " style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/online-shopping-concept-buy-in-retail-shop-by-internet-discount-sale-vector-id1286724926?k=6&m=1286724926&s=612x612&w=0&h=DcQ21UxT-H0qfYx29gZPPGd4Oo8ewt36SZYldYjCafw=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block" href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3 ">
                <div class="card p-4 ">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/shopping-online-flat-isometric-vector-concept-vector-id978317504?k=6&m=978317504&s=612x612&w=0&h=WxJrK7Yq_Do3nDYBY3oBumfgk6XjEFZYazq_Qjae84A=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card p-4 ">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/online-shopping-concept-buy-in-retail-shop-by-internet-discount-sale-vector-id1286724926?k=6&m=1286724926&s=612x612&w=0&h=DcQ21UxT-H0qfYx29gZPPGd4Oo8ewt36SZYldYjCafw=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center py-4">
            <div class="col-md-3">
                <div class="card p-4 ">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/modern-flat-design-isometric-concept-of-online-shopping-decorated-vector-id1150518945?k=6&m=1150518945&s=612x612&w=0&h=XTtmQsempT88QUeSWQEYx9oRw2q5eCi5ZRvUGqUHpZ0=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card p-4 ">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/modern-flat-design-isometric-concept-of-online-shopping-for-banner-vector-id1024208722?k=6&m=1024208722&s=612x612&w=0&h=RG6oAihpgvMcxgJC_n_iehCN6dXoFTSj4vhaC6yRsU4=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card p-4">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/women-enjoy-online-shopping-during-sale-and-discount-promotion-with-vector-id1304684803?k=6&m=1304684803&s=612x612&w=0&h=TIanj69YdQE1m4v_CuRf2m1-quwZ-_SYYFVEhKcYxjs=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center ">
            <div class="col-md-3 my-2">
                <div class="card p-4">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/online-shopping-concept-woman-buy-presents-in-retail-shop-by-internet-vector-id1285505011?k=6&m=1285505011&s=612x612&w=0&h=KhIdozYxV9h5g2ZQyppWY3eriVAESMbONaZ--o6BqyY=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card p-4">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/shopping-online-flat-isometric-vector-conceptual-illustration-vector-id1046485180?k=6&m=1046485180&s=612x612&w=0&h=3NXr35cLDc5shqllAldAVUCHPAXsriLWg2zGtjCmUeI=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card p-4 ">
                    <p class="card-title text-center" style="font-size: 25px;">اسم المتجر</p>
                    <img class="card-img-top img-fluid" src="https://media.istockphoto.com/vectors/shop-loyalty-program-isometric-landing-page-marketing-strategy-of-vector-id1272691289?k=6&m=1272691289&s=612x612&w=0&h=NWuGzN3FjA1smH4VYwcsCdXpcLXr1UW35n3KhJS6ATY=" alt="">
                    <div class="card-body">
                        <a class="btn btn-outline-primary btn-block " href="#">زيارة المتجر</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
